import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  url = `${environment.url}`

  constructor(
    private http: HttpClient
  ) { }

  save(req: { email: string }) {
    return this.http.post(
      `${this.url}/password-reset`,
      { user: { email: req.email } }
    ) as Observable<any>;
  }

  sendNewPassword(req: { token: string, password: string}){
    return this.http.post(
      `${this.url}/password-reset-complete`,
      req
    ) as Observable<any>;
  }
}
